import { useTheme } from '../contexts/themeContext';
import {
  SECTION5_BACKGROUND_LIGHT_SRC,
  SECTION5_BACKGROUND_SRC,
} from '../constants/section5Image';

/** Fond Section 5 (Méthode) — sombre ou clair selon le thème. */
export function useSection5Image() {
  const { isDark } = useTheme();

  return {
    image: isDark ? SECTION5_BACKGROUND_SRC : SECTION5_BACKGROUND_LIGHT_SRC,
  };
}
